<template>
  <div id="program-list">
    <div class="intro" v-html="introText"></div>
    <div class="programlist-wrapper">
      <div v-for="(time, day) in programList" class="day" :key="day">
        <h3>{{day}}</h3>
        <div v-for="(programs, hour) in time" class="hour" :key="hour">
          <h4>{{hour}}:00</h4>
          <div v-for="(program, index) in programs" class="program-wrapper" :key="index">
            <div class="program">
              <p class="time">{{program.time}}<span v-if="program.endTime"> - {{program.endTime}}</span></p>
              <p>{{program.title}} <a v-if="program.company" :href="url(program.companyUrl)">/ {{program.company}}</a></p>
              <br>
            </div>
            <p v-if="extra" class="description">{{program.description}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { programsIntro } from '../utils/text'

  export default {
    name: 'programList',
    props: ['programList', 'extra', 'year'],
    computed: {
      is19() {
        return this.year === '2019'
      },
      is20() {
        return this.year === '2020'
      },
      introText() {
        return programsIntro[this.year]
      },
      url() {
        return (url) => `${url}/${this.year}`
      }
    }
  }
</script>

<style scoped>
  #program-list {
    display: block;
    min-height: 100vh;
    padding: 40px 40px 80px;
    text-align: left;
    border: 10px solid var(--colorA);
  }

  .programlist-wrapper {
    display: flex;
  }

  .intro span {
    font-weight: 600;
  }

  .intro li {
    font-size: 18px;
  }

  .day {
    width: calc(50% - 20px);
  }

  .day:first-child {
    margin-right: 40px;
  }

  h3 {
    position: relative;
    font-size: 24px;
    font-weight: 800;
    margin-bottom: 40px;
    color: var(--colorB);
    text-transform: uppercase;
  }

  h3::after {
    position: absolute;
    content: '';
    width: 30px;
    height: 3px;
    left: 0;
    bottom: -15px;
    background-color: var(--colorA);
  }

  .hour h4 {
    width: 60px;
    padding-left: 15px;
  }

  .program {
    display: flex;
    min-width: 100%;
    align-items: baseline;
    margin-bottom: 15px;
    padding: 5px 15px;
    background-color: #f4f4f4;
  }

  .program p {
    font-size: 16px;
    margin: 0;
  }

  .program .time {
    margin-right: 10px;
  }

  .description {
    font-size: 16px;
    padding-left: 15px;
  }

  .program-wrapper {
    width: 100%;
  }

  @media (max-width: 768px) {
    #program-list {
      padding: 40px 20px;
    }

    .programlist-wrapper {
      flex-direction: column
    }

    .day {
      width: 100%;
    }

    .day:first-child {
      margin: 0;
    }
  }
</style>
